/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffair1ham/style.css';
import FormStructure from './thecateredaffair1ham/form_structure';

export default FormStructure;